import "./OptionChooser.css";
import React, { useState } from "react";

type QuantitySelectorProps = {
  quantity: number;
  setQuantity: (val: number) => void;
};

const QuantitySelector = ({ quantity, setQuantity }: QuantitySelectorProps) => {
  const [tempValue, setTempValue] = useState<string>(String(quantity));

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTempValue(event.target.value); // allow blank or partial typing
  };

  const handleBlur = () => {
    let parsed = parseInt(tempValue, 10);
    if (isNaN(parsed) || parsed < 1) parsed = 1;
    setQuantity(parsed);
    setTempValue(String(parsed));
  };

  const increment = () => {
    const parsed = parseInt(tempValue, 10) || quantity;
    const newVal = parsed + 1;
    setQuantity(newVal);
    setTempValue(String(newVal));
  };

  const decrement = () => {
    const parsed = parseInt(tempValue, 10) || quantity;
    const newVal = Math.max(1, parsed - 1);
    setQuantity(newVal);
    setTempValue(String(newVal));
  };

  return (
    <div className="store-front-quantity-container">
      <div className="store-front-quantity-wrapper">
        <button
          type="button"
          className="store-front-quantity-btn"
          onClick={decrement}
        >
          –
        </button>
        <input
          type="number"
          id="quantity"
          value={tempValue}
          onChange={handleChange}
          onBlur={handleBlur}
          min={1}
          className="store-front-quantity-forms"
        />
        <button
          type="button"
          className="store-front-quantity-btn"
          onClick={increment}
        >
          +
        </button>
      </div>
    </div>
  );
};

export default QuantitySelector;
